import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {RootState} from '@/store'
import {ProcessesManagementState} from "@/store/modules/processesManagement/index";
import {RequestPayload, ServiceApi} from "@payroll/optimus-common";
import {ActionTree} from 'vuex'


export const actions: ActionTree<ProcessesManagementState, RootState> = {

  fetchProcessesManagementRequest: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('fetchProcessesManagementRequest')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  approveProcessApplications: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('approveProcessApplications')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  rejectProcessApplication: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('rejectProcessApplication')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  underExaminationProcessApplication: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('underExaminationProcessApplication')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  processesManagementSettings: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('processesManagementSettings')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  updateRoutingUserProcessesManagement: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('updateRoutingUserProcessesManagement')
      .setRequestBody(requestBody)
      .put(requestorCallback);
  },

  processesManagementMessages: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('processesManagementMessages')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getUsersByProcessTypeCode: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('usersByProcessTypeCode')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  downloadProcessesManagementApplication: ({commit, dispatch, state, rootGetters}: any, {
    requestorCallback,
    pathVariable
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('downloadProcessesManagementApplication')
      .setPathVariable(pathVariable)
      .post(requestorCallback)
  },

  exportProcessesManagementDetails: ({state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('exportProcessesManagementDetails')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },


  getBanks: ({commit, dispatch, state, rootGetters}: any, {requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getBanks')
      .get(requestorCallback)
  },

  getBankBranches: ({commit, dispatch, state, rootGetters}: any, {pathVariable, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getBankBranches')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  checkIfBankAccountNumberValid: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('checkIfBankAccountNumberValid')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  createNewRequestByMangeCompany: ({commit, dispatch, state, rootGetters}: any, {requestBody, pathVariable, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('createNewRequestByMangeCompany')
      .setRequestBody(requestBody)
      .setPathVariable(pathVariable)
      .post(requestorCallback)
  },


  uploadProcessAttachment: ({commit, dispatch, state, rootGetters}: any, {formData, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('uploadProcessAttachment')
      .setFormData(formData)
      .post(requestorCallback)
  },

  getSecondPartDetailsChangeInvestment: ({commit, dispatch, state, rootGetters}: any, {formData, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getSecondPartDetailsChangeInvestment')
      .setFormData(formData)
      .post(requestorCallback)
  },
}